module.exports = __webpack_public_path__ + "media/img/star-e045cf7dfdba7cae5bf819824f5b7aae.svg";